import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'

export interface Alarm {
  id: number
  name: string
  description: string
}
export type AddAlarm = Pick<Alarm, 'name' | 'description'>
export type EditAlarm = Alarm
export interface AlarmStore {
  alarms: Alarm[]
}

export const alarmStore: Module<AlarmStore, {}> = {
  namespaced: true,
  state: () => ({
    alarms: []
  }),
  mutations: {
    getAll(state, payload: Alarm[]) {
      state.alarms = payload
    }
  },
  actions: {
    async getAll({ commit }) {
      const { data } = await axios(`${BASE_API_URL}/alarm`)
      commit('getAll', data)
    },
    async add({ dispatch }, payload: AddAlarm) {
      const { data } = await axios.post(`${BASE_API_URL}/alarm`, payload)
      await dispatch('getAll')
      return data
    },
    async edit({ dispatch }, { id, ...alarm }: EditAlarm) {
      const { data } = await axios.put(`${BASE_API_URL}/alarm/${id}`, alarm)
      await dispatch('getAll')
      return data
    },
    async get(_, id: string) {
      const { data } = await axios.get(`${BASE_API_URL}/alarm/${id}`)
      return data
    }
  },
  getters: {
    alarms: state => state.alarms
  }
}
